import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import "../AllPrint.css";
import converter from "number-to-words";
class SellPrintEnglish extends Component {
 render() {
  const {
   lang,
   change_Lang,
   sell_invoice_obj,
   index_sell_contract,
   user,
   primary_logo,
   thirdcolor,
   footer_logo,
   name_en,
  } = this.props;
  // English
  let converter1 =
   sell_invoice_obj.introduction &&
   converter.toWords(sell_invoice_obj.introduction);
  let converter2 =
   sell_invoice_obj.lastPrice && converter.toWords(sell_invoice_obj.lastPrice);
  let converter3 =
   sell_invoice_obj.reject && converter.toWords(sell_invoice_obj.reject);
  let converter4 =
   sell_invoice_obj.pay && converter.toWords(sell_invoice_obj.pay);
  let converter5 =
   sell_invoice_obj.fee && converter.toWords(sell_invoice_obj.fee);

  return (
   <>
    {/* New One */}
    <div className={`${lang === "en" ? "" : " fk "}`}>
     <div className="row content-containers" id="tbls">
      <div className="col-12">
       <div class="card product-page-main card-body">
        <div class="card-body p-0" id="yy">
         <div className="conn">
          <div class="row">
           <div class="col-12  ">
            <img
             src={primary_logo}
             alt="logo"
             style={{ width: "100%" }}
             className="img-fluid img-responsive"
            />
           </div>
          </div>
          <div class="row mt-3">
           <div class="col-4">
            <p
             style={{
              fontSize: "16px",
              color: "#2e425d",
              textAlign: "left",
              fontWeight: "bold",
             }}
             class=" text-uppercase"
            >
             &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
             <Time
              value={sell_invoice_obj.createdAt}
              format="YYYY-MM-DD"
              style={{
               fontSize: "16px",
               color: "#2e425d",
               fontWeight: "bold",
              }}
             />
            </p>
           </div>
           <div class="col-4 d-flex justify-content-center">
            <p
             style={{
              fontSize: "20px",
              color: "#2e425d",
              fontWeight: "bolder",
             }}
             class={`d-flex justify-content-center text-uppercase ${
              lang !== "en" ? "fk" : "fkp"
             } `}
            >
             ({change_Lang("sale and purchase contract")})
            </p>
           </div>
           <div class="col-4 text-right">
            <p
             style={{
              fontSize: "16px",
              color: "#2e425d",
              fontWeight: "bold",
             }}
             class=" text-uppercase"
            >
             {change_Lang("contract number")} # &nbsp;&nbsp;
             {index_sell_contract}&nbsp;&nbsp;
            </p>
           </div>
          </div>
          <div class="row mt-3">
           <div class="col-12">
            <div class="form-group row form-inline">
             <label
              style={{
               fontSize: "18px",
               color: "black",
               fontWeight: "bold",
              }}
              class="col-sm-2 col-form-label"
             >
              {change_Lang("First Side")}:
             </label>
             <div class="col-sm-4">
              <label
               class="d-flex justify-content-start"
               style={{ fontWeight: "bold", fontSize: "18px" }}
              >
               {sell_invoice_obj.firstname}
              </label>
             </div>
             <label
              style={{
               fontSize: "18px",
               color: "black",
               fontWeight: "bold",
              }}
              class="col-sm-2 col-form-label"
             >
              {/* {change_Lang("Witness")}: */}
              {change_Lang("Second Side")}:
             </label>
             <div class="col-sm-4">
              <label
               class="d-flex justify-content-start"
               style={{ fontWeight: "bold", fontSize: "18px" }}
              >
               {sell_invoice_obj.secondname}
              </label>
             </div>
             {/* phone */}
             <label
              style={{
               fontSize: "22px",
               color: "black",
               fontWeight: "bold",
              }}
              class="col-sm-2 col-form-label fkk"
             >
              Phone:
             </label>
             <div class="col-sm-4">
              <label
               class="d-flex justify-content-start"
               style={{ fontWeight: "bold", fontSize: "18px" }}
              >
               {sell_invoice_obj.phone1}
              </label>
             </div>

             <label
              style={{
               fontSize: "22px",
               color: "black",
               fontWeight: "bold",
              }}
              class="col-sm-2 col-form-label fkk"
             >
              Phone:
             </label>
             <div class="col-sm-4">
              <label
               class="d-flex justify-content-start"
               style={{ fontWeight: "bold", fontSize: "18px" }}
              >
               {sell_invoice_obj.phone2}
              </label>
             </div>
             <label
              style={{
               fontSize: "18px",
               color: "black",
               fontWeight: "bold",
              }}
              class="col-sm-2 col-form-label"
             >
              {" "}
              {change_Lang("first_rule_place")}:
             </label>
             <br />
             <div class="col-sm-4">
              <label
               class="d-flex justify-content-start"
               style={{ fontWeight: "bold", fontSize: "18px" }}
              >
               {sell_invoice_obj.available_id &&
                sell_invoice_obj.available_id.Place_ku}
              </label>
             </div>
             {/* shahed 2 */}
             <label
              style={{
               fontSize: "18px",
               color: "black",
               fontWeight: "bold",
              }}
              class="col-sm-2 col-form-label"
             >
              {" "}
              property:
             </label>
             <div class="col-sm-4">
              <label
               class="d-flex justify-content-start"
               style={{ fontWeight: "bold", fontSize: "18px" }}
              >
               {/* {sell_invoice_obj.witness2} */}
               {change_Lang(
                sell_invoice_obj.available_id &&
                 sell_invoice_obj.available_id.Property
               )}
              </label>
             </div>
             {/* Area */}
             <label
              style={{
               fontSize: "18px",
               color: "black",
               fontWeight: "bold",
              }}
              class="col-sm-2 col-form-label"
             >
              Number:
             </label>
             <br />
             <div class="col-sm-4">
              <label
               class="d-flex justify-content-start"
               style={{ fontWeight: "bold", fontSize: "18px" }}
              >
               {sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.Property !== "Apartment" ? (
                <>
                 {sell_invoice_obj.available_id &&
                  sell_invoice_obj.available_id.NOoFProperty}
                </>
               ) : (
                ""
               )}
               {sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.Property === "Apartment" ? (
                <>
                 &nbsp; &nbsp;
                 {sell_invoice_obj.available_id &&
                  sell_invoice_obj.available_id.block}{" "}
                 &nbsp;-&nbsp;
                 {sell_invoice_obj.available_id &&
                  sell_invoice_obj.available_id.flour}
                 &nbsp;-&nbsp;{" "}
                 {sell_invoice_obj.available_id &&
                  sell_invoice_obj.available_id.NOoFProperty}
                 &nbsp;&nbsp;
                </>
               ) : (
                ""
               )}
              </label>
             </div>
             {/* shahed 2 */}
             <label
              style={{
               fontSize: "18px",
               color: "black",
               fontWeight: "bold",
              }}
              class="col-sm-2 col-form-label"
             >
              {" "}
              {/* {change_Lang("Witness")}: */}
              {change_Lang("Area")}:
             </label>
             <div class="col-sm-4">
              <label
               class="d-flex justify-content-start"
               style={{ fontWeight: "bold", fontSize: "18px" }}
              >
               {/* {sell_invoice_obj.witness2} */}
               {sell_invoice_obj.available_id &&
                sell_invoice_obj.available_id.Area}
               &nbsp;m<sup>2</sup>
              </label>
             </div>
            </div>
            <p
             style={{
              fontSize: "24px",
              color: "#000",
              backgroundColor: "#ebebeb",
              borderRadius: "0px 50px 0px 0px",
             }}
             class="my-3 d-flex justify-content-center fk"
            >
             {change_Lang("agreement")}
            </p>
           </div>
          </div>
          <div className="row ">
           <div className="col-12">
            <table className="table table-borderless">
             <tbody>
              <tr
               style={{
                fontSize: "15px",
               }}
              >
               <th
                className={`${lang !== "en" ? "fk" : "fkp"}`}
                scope="row"
                style={{
                 color: `${thirdcolor}`,
                 borderTop: "none",
                 paddingBottom: "35px",
                 listStyleType: "circle",
                 fontSize: "20px",
                }}
               >
                1.
               </th>
               <td
                style={{
                 lineHeight: "1.5",
                 wordSpacing: "1px",
                 color: "black",
                 fontWeight: "",
                 textAlign: "justify",
                 fontSize: "22px",
                 borderTop: "none",
                }}
               >
                I am the first side ({sell_invoice_obj.firstname}) the owner of
                the property agreed to sell the above mentioned property for an
                amount of{" "}
                <NumberFormat
                 displayType="text"
                 thousandSeparator={true}
                 value={sell_invoice_obj ? sell_invoice_obj.lastPrice : 0}
                 required
                 className="text-center"
                 prefix={"$"}
                />
                &nbsp;&nbsp; ({converter2}
                &nbsp;US&nbsp;dollars).
               </td>
              </tr>
              <tr
               style={{
                fontSize: "15px",
               }}
              >
               <th
                className={`${lang !== "en" ? "fk" : "fkp"}`}
                scope="row"
                style={{
                 color: `${thirdcolor}`,
                 borderTop: "none",
                 paddingBottom: "35px",
                 listStyleType: "circle",
                 fontSize: "20px",
                }}
               >
                2.
               </th>
               <td
                style={{
                 lineHeight: "1.5",
                 wordSpacing: "1px",
                 color: "black",
                 fontWeight: "",
                 textAlign: "justify",
                 fontSize: "22px",
                 borderTop: "none",
                }}
               >
                I am the second side ({sell_invoice_obj.secondname}) accepted to
                purchase the above mentioned property for an amount of&nbsp;
                <NumberFormat
                 displayType="text"
                 thousandSeparator={true}
                 value={sell_invoice_obj ? sell_invoice_obj.lastPrice : 0}
                 required
                 className="text-center"
                 prefix={"$"}
                />
                &nbsp;&nbsp; ({converter2}
                &nbsp;US&nbsp;dollars).
               </td>
              </tr>
              <tr
               style={{
                fontSize: "15px",
               }}
              >
               <th
                className={`${lang !== "en" ? "fk" : "fkp"}`}
                scope="row"
                style={{
                 color: `${thirdcolor}`,
                 borderTop: "none",
                 paddingBottom: "35px",
                 listStyleType: "circle",
                 fontSize: "20px",
                }}
               >
                3.
               </th>
               <td
                style={{
                 lineHeight: "1.5",
                 wordSpacing: "1px",
                 color: "black",
                 fontWeight: "",
                 textAlign: "justify",
                 fontSize: "22px",
                 borderTop: "none",
                }}
               >
                The Second side shall pay an amount of&nbsp;
                <NumberFormat
                 displayType="text"
                 thousandSeparator={true}
                 value={sell_invoice_obj ? sell_invoice_obj.introduction : 0}
                 required
                 className="text-center"
                 prefix={"$"}
                />
                &nbsp; ({converter1}
                &nbsp;US &nbsp;dollars) to the first side as an advance, and The
                remaining amount &nbsp;(
                <NumberFormat
                 displayType="text"
                 thousandSeparator={true}
                 value={sell_invoice_obj.pay}
                 className="text-center"
                 prefix={"$"}
                />
                &nbsp; ({converter4}
                &nbsp;US &nbsp;dollars) must be pay on the date&nbsp;(
                <Time value={sell_invoice_obj.pay_day} format="YYYY-MM-DD" />
                )&nbsp;pay in (cash or installment).
               </td>
              </tr>
              <tr
               style={{
                fontSize: `${
                 lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
                }`,
               }}
              >
               <th
                className={`${lang !== "en" ? "fk" : "fkp"}`}
                scope="row"
                style={{
                 color: `${thirdcolor}`,
                 borderTop: "none",
                 paddingBottom: "35px",
                 listStyleType: "circle",
                 fontSize: "20px",
                }}
               >
                4.
               </th>
               <td
                style={{
                 lineHeight: "1.5",
                 wordSpacing: "1px",
                 color: "black",
                 fontWeight: "",
                 textAlign: "justify",
                 fontSize: "22px",
                 borderTop: "none",
                }}
               >
                The first side shall hand over the property to the second side
                after receiving all its financial dues on date&nbsp;
                <Time value={sell_invoice_obj.duedate} format="YYYY-MM-DD" />.
               </td>
              </tr>
              <tr
               style={{
                fontSize: `${
                 lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
                }`,
               }}
              >
               <th
                className={`${lang !== "en" ? "fk" : "fkp"}`}
                scope="row"
                style={{
                 color: `${thirdcolor}`,
                 borderTop: "none",
                 paddingBottom: "35px",
                 listStyleType: "circle",
                 fontSize: "20px",
                }}
               >
                5.
               </th>
               <td
                style={{
                 lineHeight: "1.5",
                 wordSpacing: "1px",
                 color: "black",
                 fontWeight: "",
                 textAlign: "justify",
                 fontSize: "22px",
                 borderTop: "none",
                }}
               >
                In the event that the first side is late in handing over the
                property to the second side, it must pay an amount of &nbsp;
                <NumberFormat
                 displayType="text"
                 thousandSeparator={true}
                 value={sell_invoice_obj.reject}
                 className="text-center"
                 prefix={"$"}
                />
                &nbsp; ({converter3}
                &nbsp;US &nbsp;dollars) &nbsp; as a fine for each day of delay.
               </td>
              </tr>
              <tr
               style={{
                fontSize: `${
                 lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
                }`,
               }}
              >
               <th
                className={`${lang !== "en" ? "fk" : "fkp"}`}
                scope="row"
                style={{
                 color: `${thirdcolor}`,
                 borderTop: "none",
                 paddingBottom: "35px",
                 listStyleType: "circle",
                 fontSize: "20px",
                }}
               >
                6.
               </th>
               <td
                style={{
                 lineHeight: "1.5",
                 wordSpacing: "1px",
                 color: "black",
                 fontWeight: "",
                 textAlign: "justify",
                 fontSize: "22px",
                 borderTop: "none",
                }}
               >
                The first side shall liquidate the costs and fees of water and
                electricity or any other loan before the date of handing over
                the above mention property.
               </td>
              </tr>
              <tr
               style={{
                fontSize: `${
                 lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
                }`,
               }}
              >
               <th
                className={`${lang !== "en" ? "fk" : "fkp"}`}
                scope="row"
                style={{
                 color: `${thirdcolor}`,
                 borderTop: "none",
                 paddingBottom: "35px",
                 listStyleType: "circle",
                 fontSize: "20px",
                }}
               >
                7.
               </th>
               <td
                style={{
                 lineHeight: "1.5",
                 wordSpacing: "1px",
                 color: "black",
                 fontWeight: "",
                 textAlign: "justify",
                 fontSize: "22px",
                 borderTop: "none",
                }}
               >
                For any reason for the retraction of one of the two sides, he
                must pay a penalty of amount &nbsp;
                <NumberFormat
                 displayType="text"
                 thousandSeparator={true}
                 value={sell_invoice_obj.fee}
                 className="text-center"
                 prefix={"$"}
                />
                &nbsp; ({converter5}
                &nbsp;US &nbsp;dollars).
               </td>
              </tr>
              <tr
               style={{
                fontSize: `${
                 lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
                }`,
               }}
              >
               <th
                className={`${lang !== "en" ? "fk" : "fkp"}`}
                scope="row"
                style={{
                 color: `${thirdcolor}`,
                 borderTop: "none",
                 paddingBottom: "35px",
                 listStyleType: "circle",
                 fontSize: "20px",
                }}
               >
                8.
               </th>
               <td
                style={{
                 lineHeight: "1.5",
                 wordSpacing: "1px",
                 color: "black",
                 fontWeight: "",
                 textAlign: "justify",
                 fontSize: "22px",
                 borderTop: "none",
                }}
               >
                The costs and fees of sale, transportation, sorting,
                consolidation, modification, and real estate tax are borne by
                the first side in accordance with the law if the property has a
                title deed. In the event that the property does not have a title
                deed, the first side must pay the costs of transferring
                ownership.
               </td>
              </tr>
             </tbody>
            </table>
           </div>
          </div>
         </div>
         <div className="row content-containers mt-4" id="tbls_two">
          <div class="col-12  ">
           <img
            src={primary_logo}
            style={{ width: "100%" }}
            alt="logo"
            className="img-fluid img-responsive"
           />
          </div>
         </div>
         <br /> <br />
         <div className="row">
          <div className="col-12">
           <table className="table table-borderless">
            <tbody>
             <tr
              style={{
               fontSize: `${
                lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
               }`,
              }}
             >
              <th
               className={`${lang !== "en" ? "fk" : "fkp"}`}
               scope="row"
               style={{
                color: `${thirdcolor}`,
                borderTop: "none",
                paddingBottom: "35px",
                listStyleType: "circle",
                fontSize: "20px",
               }}
              >
               9.
              </th>
              <td
               style={{
                lineHeight: "1.5",
                wordSpacing: "1px",
                color: "black",
                fontWeight: "",
                textAlign: "justify",
                fontSize: "22px",
                borderTop: "none",
               }}
              >
               The second side is responsible for paying the inspection and real
               estate registration fees according to the law if the property has
               a title deed, and if the property does not have a title deed, the
               second side must pay the registration costs.
              </td>
             </tr>
             <tr
              style={{
               fontSize: `${
                lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
               }`,
              }}
             >
              <th
               className={`${lang !== "en" ? "fk" : "fkp"}`}
               scope="row"
               style={{
                color: `${thirdcolor}`,
                borderTop: "none",
                paddingBottom: "35px",
                listStyleType: "circle",
                fontSize: "20px",
               }}
              >
               10.
              </th>
              <td
               style={{
                lineHeight: "1.5",
                wordSpacing: "1px",
                color: "black",
                fontWeight: "",
                textAlign: "justify",
                fontSize: "22px",
                borderTop: "none",
               }}
              >
               After signing this contract in the event that the sold property
               has a title deed, the first side must grant an agency to attorney
               ({sell_invoice_obj.lawman}) for the purpose of transferring
               ownership and registering the sold property for the benefit of
               the second party.
              </td>
             </tr>
             <tr
              style={{
               fontSize: `${
                lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
               }`,
              }}
             >
              <th
               className={`${lang !== "en" ? "fk" : "fkp"}`}
               scope="row"
               style={{
                color: `${thirdcolor}`,
                borderTop: "none",
                paddingBottom: "35px",
                listStyleType: "circle",
                fontSize: "20px",
               }}
              >
               11.
              </th>
              <td
               style={{
                lineHeight: "1.5",
                wordSpacing: "1px",
                color: "black",
                fontWeight: "",
                textAlign: "justify",
                fontSize: "22px",
                borderTop: "none",
               }}
              >
               The first side and the second side undertakes to pay 1% of the
               price of the property mentioned in this contract to the {name_en}{" "}
               for the sale of the property.
              </td>
             </tr>
             <tr
              style={{
               fontSize: `${
                lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
               }`,
              }}
             >
              <th
               className={`${lang !== "en" ? "fk" : "fkp"}`}
               scope="row"
               style={{
                color: `${thirdcolor}`,
                borderTop: "none",
                paddingBottom: "35px",
                listStyleType: "circle",
                fontSize: "20px",
               }}
              >
               12.
              </th>
              <td
               style={{
                lineHeight: "1.5",
                wordSpacing: "1px",
                color: "black",
                fontWeight: "",
                textAlign: "justify",
                fontSize: "22px",
                borderTop: "none",
               }}
              >
               In the event of any dispute about the content of this contract,
               the two parties must resolve it through dialogue, otherwise the
               Slemani court will be the place to decide the cases.
              </td>
             </tr>
             <tr
              style={{
               fontSize: `${
                lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
               }`,
              }}
             >
              <th
               className={`${lang !== "en" ? "fk" : "fkp"}`}
               scope="row"
               style={{
                color: `${thirdcolor}`,
                borderTop: "none",
                paddingBottom: "35px",
                listStyleType: "circle",
                fontSize: "20px",
               }}
              >
               13.
              </th>
              <td
               style={{
                lineHeight: "1.5",
                wordSpacing: "1px",
                color: "black",
                fontWeight: "",
                textAlign: "justify",
                fontSize: "22px",
                borderTop: "none",
               }}
              >
               The first side and the second side, after signing the contract,
               are not entitled to claim the commission given to the {name_en}.
              </td>
             </tr>
             <tr
              style={{
               fontSize: `${
                lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
               }`,
              }}
             >
              <th
               className={`${lang !== "en" ? "fk" : "fkp"}`}
               scope="row"
               style={{
                color: `${thirdcolor}`,
                borderTop: "none",
                paddingBottom: "35px",
                listStyleType: "circle",
                fontSize: "20px",
               }}
              >
               14.
              </th>
              <td
               style={{
                lineHeight: "1.5",
                wordSpacing: "1px",
                color: "black",
                fontWeight: "",
                textAlign: "justify",
                fontSize: "22px",
                borderTop: "none",
               }}
              >
               The company's job is only mediation. It is not responsible for
               any problem or dispute that occurs between the seller and the
               buyer.
              </td>
             </tr>
            </tbody>
           </table>
          </div>
         </div>
         <br />
         <div className="form-inline">
          <label
           style={{
            fontSize: "18px",
            fontWeight: "bolder",
            color: "#000",
            marginRight: "10px",
           }}
           className="form-label d-flex justify-content-start"
          >
           {change_Lang("note")}&nbsp;:
          </label>
          &nbsp;&nbsp;&nbsp;
          <label
           style={{
            fontSize: "16px",
            color: "black",
            fontWeight: "bold",
            wordSpacing: "4px",
            textAlign: "justify",
           }}
           className="form-label d-flex justify-content-start"
          >
           {sell_invoice_obj.note}
          </label>
         </div>
         <br /> <br /> <br /> <br /> <br />
         <br />
         <br />
         <div className="row">
          <div className="form-group d-flex justify-content-center col-4">
           <label
            style={{
             fontSize: "18px",
             color: "#2e425d",
             fontWeight: "bold",
            }}
            className="form-label"
           >
            First Party (Seller)
           </label>
          </div>

          <div className="col-4">
           <div className="form-group d-flex justify-content-center">
            <label
             style={{
              fontSize: "18px",
              color: "#2e425d",
              fontWeight: "bold",
             }}
             className="form-label"
            >
             Contract Organizor
            </label>
           </div>
          </div>
          <div className="col-4">
           <div className="form-group d-flex justify-content-center">
            <label
             style={{
              fontSize: "18px",
              color: "#2e425d",
              fontWeight: "bold",
             }}
             className="form-label"
            >
             Second Party (Buyer)
            </label>
           </div>
          </div>
         </div>
         <div className="row">
          <div className="col-4 form-group d-flex justify-content-center">
           <label
            style={{
             fontSize: "18px",
             color: "#000",
            }}
            className="form-label"
           >
            {sell_invoice_obj.firstname}
           </label>
          </div>
          <div className="col-4 form-group d-flex justify-content-center">
           <label
            style={{
             fontSize: "18px",
             color: "#000",
            }}
            className="form-label"
           >
            {`${sell_invoice_obj.agentId && sell_invoice_obj.agentId.fname} ${
             sell_invoice_obj.agentId && sell_invoice_obj.agentId.lname
            }`}
           </label>
          </div>
          <div className="col-4">
           <div className="form-group d-flex justify-content-center">
            <label
             style={{
              fontSize: "18px",
              color: "#000",
             }}
             className="form-label"
            >
             {sell_invoice_obj.secondname}
            </label>
           </div>
          </div>
         </div>
         {/* footer */}
         <div
          className="row"
          style={{
           position: "fixed",
           bottom: 5,
           width: "100%",
           marginRight: "20px",
          }}
         >
          <div className="col-12">
           <img src={footer_logo} alt="logo" width="100%" />
          </div>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  index_sell_contract: state.Invoice_Reducer.index_sell_contract,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_en: state.HelperReducer.name_en,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(SellPrintEnglish);
